module.exports = __webpack_public_path__ + "static/media/climate_agriculture_2_density.8513edc0.jpg";